import { BlockError } from '@/blocks.04-project/block-error/block-error';

/**
 * Класс фильтра
 * @example
 *
 * Аттрибуты:
 * data-scroll-target - {string} - селектор элемента до которого будет скролится страница при клике на тултип
 *
 * Методы:
 * showTooltip({ text, target, placement }) - открытие тултипа
 */
class Filter {
  /***
   * Конструктор класса
   * @param elem {HTMLElement} DOM элемент формы с классом filter
   */
  constructor(elem) {
    this.BlockError = new BlockError({ blockName: 'Filter', destroy: this.destroy });
    if (!elem) return this.BlockError.error('Отсутствует elem');
    this.block = elem;
    this.block.Filter = this;

    this.init();
  }

  init = () => {
    this.tooltip = null;
    this.lastChangedSection = this.block;

    this.scrollTargetSelector = this.block.dataset['scrollTarget'];
    if (this.scrollTargetSelector) {
      this.scrollTarget = document.querySelector(this.scrollTargetSelector);
      if (!this.scrollTarget) return this.BlockError.error(`Отсутствует ${this.scrollTargetSelector}`);
    }

    document.body.addEventListener('click', this.outClickHandler);
    this.block.addEventListener('change', this.changeHandler);

    if (NOT_PROD) this.block.addEventListener('change', () => this.showTooltip({ text: '25 товаров' }));

    this.block.classList.add('filter_inited');
  };

  /** Клик за пределами элемента закрывает тултип */
  outClickHandler = () => {
    if (this.tooltip && this.tooltip.tip) this.tooltip.dispose();
  };

  /**
   * Получение последнего изменённого чекбокса
   * @param target{HTMLElement}
   */
  changeHandler = ({ target }) => {
    const checkbox = target.closest('.filter .form-check');
    if (!checkbox) return;

    this.lastChangedSection = checkbox;
  };

  /**
   * Отображение тултипа
   * @param text {String} - текст тултипа
   * @param target {HTMLElement|undefined} - элемент где нужно показать тултип, если нужно, по умолчанию берёт последний нажатый чекбокс
   * @param placement {String} - позиционирование тултипа
   */
  showTooltip = ({ text, target, placement = 'right' }) => {
		this.outClickHandler();
    const container = target || this.lastChangedSection;
    this.tooltip = new window.bootstrap.Tooltip(container, {
      container,
      placement,
      fallbackPlacements: [placement],
      offset: [0, 16],
      trigger: 'manual',
      customClass: 'filter-tooltip tooltip-black',
      title: text || '',
    });

    this.tooltip.show();
    this.tooltip.tip.addEventListener('mouseleave', () => this.tooltip.hide(), { once: true });
    this.tooltip.tip.addEventListener('click', () => {
      if (this.scrollTarget) this.scrollTarget.scrollIntoView();
      else window.scrollTo(0, 0);
    }, { once: true });
  };

  destroy = () => {
    document.body.removeEventListener('click', this.outClickHandler);
    if (this.tooltip && this.tooltip.tip) this.tooltip.dispose();
    if (this.block) {
      this.block.removeEventListener('change', this.changeHandler);
      this.block.classList.remove('filter_inited');
      delete this.block.Filter;
    }
  };

  static init() {
    Array.from(document.querySelectorAll('.filter:not(.filter_inited)')).forEach((elem) => new Filter(elem));
  }
}

document.addEventListener('DOMContentLoaded', Filter.init);

// Экспорт;
window.Block.Filter = Filter;
